import { useQuery } from '@apollo/client';

import { AccountNotifications } from '~/components/AccountNotifications';
import ConnectorLayout from '~/components/layouts/ConnectorLayout';
import Tile from '~/images/Tiles/Enrichment.svg';
import {
  integrationTabs as objectTypes,
  readableType,
} from '~/lib/dataEnrichment';
import paths from '~/lib/paths';
import { connectorLocations } from '~/lib/segmentAnalytics';

import { IntegrationTabs, useIntegrationTabState } from '../IntegrationTabs';
import FieldMappingForm from './FieldMappingForm';
import query from './query.graphql';
import WebhookConfig from './WebhookConfigTab';

const EnrichmentShow = ({
  integration,
  objectType = objectTypes[integration][0].name,
}) => {
  const { currentTab } = useIntegrationTabState({
    integration,
    tabName: objectType,
  });
  const {
    data: { accountNotifications },
  } = useQuery(query, {
    returnPartialData: true,
    variables: {
      service: integration,
    },
  });

  return (
    <ConnectorLayout
      breadcrumb={[
        {
          title: 'Enrichment',
          path: paths.dataEnrichmentIndex(),
        },
      ]}
      connectorLocation={connectorLocations.enrichment}
      integration={integration}
      subtitle={`Sync Clearbit data to ${readableType(integration)}`}
      tabs={<IntegrationTabs integration={integration} tabName={objectType} />}
      tile={<Tile />}
    >
      <AccountNotifications
        className="mx-10 mt-6 mb-2"
        isFromEnrichmentPage
        notifications={accountNotifications}
      />
      <div className="h-full px-8">
        {currentTab.name === 'webhook' ? (
          <WebhookConfig integration={integration} />
        ) : (
          <FieldMappingForm integration={integration} objectType={currentTab} />
        )}
      </div>
    </ConnectorLayout>
  );
};

export default EnrichmentShow;
